import { BaseComponent } from '@/src/app/shared/components/base-component/base.component';
import {
  DataTableDataProvider,
  GenericDataTableDataProvider
} from '@/src/app/shared/modules/general-commons/components/data-table/data-table-data-provider';
import { FileUtils } from '@/src/app/utils/file.utils';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { SearchFilterService } from '../../../search/services/search-filter.service';
import { PartnerSearchModel } from '../../models/partner-search.model';
import { PartnerService } from '../../partner.service';
import { WsHelperService } from '@shared/services/ws-helper.service';
import { GlobalErrorHandlerService } from '@shared/services/global-error-handler.service';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';
import { PageHeaderComponent } from '@shared/modules/general-commons/components/page-header/page-header.component';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { DataTableComponent } from '@shared/modules/general-commons/components/data-table/data-table.component';
import { MatRowDef, MatRow } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-partner-search-page',
  templateUrl: './partner-search-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SearchFilterService],
  imports: [GenericWidePageComponent, PageHeaderComponent, PartnerSearchComponent, DataTableComponent, MatRowDef, MatRow, TranslateModule]
})
export class PartnerSearchPageComponent extends BaseComponent implements OnInit {
  private partnerService = inject(PartnerService);
  private searchFilterService = inject(SearchFilterService);
  private wsHelperService = inject(WsHelperService);
  private globalErrorHandlerService = inject(GlobalErrorHandlerService);

  private searchFilters: PartnerSearchModel;
  searchResultsDataProvider: DataTableDataProvider<any>;
  constructor() {
    super();
    const partnerService = this.partnerService;
    const wsHelperService = this.wsHelperService;
    const globalErrorHandlerService = this.globalErrorHandlerService;

    this.searchResultsDataProvider = new GenericDataTableDataProvider(
      {
        loadFunction: pageSort => wsHelperService.callWithSpinner(partnerService.getPartners(pageSort, this.searchFilters))
      },
      wsHelperService,
      globalErrorHandlerService
    );
  }
  ngOnInit(): void {
    this.subSink.sink = this.searchFilterService.searchEvent$.subscribe((searchFilters: PartnerSearchModel) => {
      this.searchFilters = searchFilters;
      this.searchResultsDataProvider.reload();
    });

    this.subSink.sink = this.searchFilterService.csvDownloadEvent$.subscribe((searchFilters: PartnerSearchModel) => {
      this.wsHelperService.call(this.partnerService.getPartnersCsvFile(searchFilters)).subscribe(res => {
        FileUtils.downloadFile(res, 'STX-partners.csv');
      });
    });
  }
}
